module.exports = __webpack_public_path__ + "img/6.06c68749.jpg";